module.exports = __webpack_public_path__ + "img/building1.07f2cd9d.jpg";